// @ts-nocheck
import packageConfig from '../package.json';

let PACKAGE_VERSION = packageConfig.version;
if (process.env.NODE_ENV === 'production') PACKAGE_VERSION = PACKAGE_VERSION.replace('-dev', '');

export default PACKAGE_VERSION;
